module.exports = __webpack_public_path__ + "startpage-746fed5a/cagdas-aygun-6d5b9a44410bb6f625ffdb2d312578a9.jpg";